import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextBookmark(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2Zm0 15-5-2.18L7 18V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
